import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class CandidateInfoEditService extends SendRequest
{
    async UpdateCanidateInfo(params, router)
    {
        var candidate_update_info = API.client.applicant.CANDIDATE_UPDATE_INFO.replace('$applicant_id', router.query.applicant_id);
        
        try 
        {
              const result = await axios.post(candidate_update_info,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON())
              return result;
        } 
        catch(error) 
        {
          return error;
        }
    }


    async UpdateGeneralCandidate(params, router)
    {
        var url = API.client.candidates.UPDATE_CANDIDATE.replace('$candidate_id', router.query.candidate_id);
        try 
        {
              const result = await axios.put(url,
              params,
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON())
              return result;
        } 
        catch(error) 
        {
          return error;
        }
    }

  async getReferralUsers() {
  
    let url = API.referral_users;
    try {
      const result = await axios.get(url,
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

  async getAgencyUsers() {

    let url = API.agency_users;
    try {
      const result = await axios.get(url,
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }

    async LoadMoreDocuments(params, application_id)
    {
        var url = API.client.applicant.CANDIDATE_INFO.replace('$application_id', application_id);
      try
      {
        const result = await axios.get(url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async LoadMoreDocumentsGeneralView(params, candidate_id) {
    var url = API.client.applicant.GENERAL_PROFILE.replace('$candidate_id', candidate_id);
    try {
      const result = await axios.get(url,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }
}
